<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-info">
        <div class="footer-nav">
          <router-link
            :to="item.path"
            class="nav-link"
            v-for="item in navFooter"
            >{{ item.name }}</router-link
          >
          <!-- <router-link to="/column/academy_news_information" class="nav-link"
            >新闻资讯</router-link
          >
          <router-link to="/column/academy_innovation_project" class="nav-link"
            >科技创新</router-link
          >
          <router-link
            to="/column/academy_cooperation_education"
            class="nav-link"
            >外部合作</router-link
          > -->
          <router-link to="/contact" class="nav-link">联系我们</router-link>
        </div>
        <p class="cont">
          <span>电话：0553-8756237</span>
          <span>邮箱：liuyoujun@37.com</span>
          <span>邮编：241000</span>
        </p>
        <p>地址：安徽省芜湖市鸠江区皖江财富广场B1座6楼6001号</p>
      </div>
      <div class="copyright">
        <p>
          版权所有：安徽省数字文化产业创新研究院
          &nbsp;&nbsp;&nbsp;&nbsp;皖B2-20190099-6号
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  inject: ["NavList"],
  computed: {
    navFooter() {
      return (this.NavList() || []).map((d) => ({
        name: d.name,
        path:
          d.children && d.children.length
            ? `/column/${d.children[0].code}`
            : `/column/${d.code}`,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.site-footer {
  //   background: #003366;
  color: #fff;
  //   padding: 20px 0;

  .footer-content {
    text-align: center;

    .footer-info {
      padding: 20px 0;
      font-size: 14px;
      background-color: #e2f5f9;
      color: #222;
      p {
        margin: 5px 0;
      }
    }
    .footer-nav {
      margin: 30px;
    }
    .nav-link {
      font-size: 18px;
      padding: 0 20px;
      font-weight: bold;
      color: #222;
      line-height: 1;
      position: relative;
      &::after {
        content: "";
        height: 16px;
        width: 3px;
        background: #193d65;
        position: absolute;
        right: 0;
        top: 4px;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
      &:hover {
        color: #193d65;
      }
    }
    .cont {
      span {
        margin: 0 20px;
      }
    }
    .copyright {
      background-color: #192f58;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      padding: 20px 0;
      font-size: 16px;
      a {
        color: #1890ff;
        text-decoration: none;
      }
    }
  }
}
</style>
